import { useContext, useEffect, useState } from 'react'
import { useAppSelector } from '../../../../../redux/hooks';
import { CesiumViewerContext } from '../cesiumviewer/CesiumViewer'
import Paper from '@mui/material/Paper';
import './MapInfo.scss'
import {ScreenSpaceEventHandler, Cartographic, ScreenSpaceEventType} from 'cesium';


function padCoordinate(num: number): string {
    return num.toFixed(7)
}

interface Props {
    time: string;
}

export default function MapInfo(props: Props) {
    const viewer = useContext(CesiumViewerContext);

    const layerConfig = useAppSelector(state => state.layerConfig);

    const [coordinate, setCoordinate] = useState({
        lon: '---', 
        lat: '---'
    });

    const [time, setTime] = useState<string>('');

    useEffect(() => {
        setTime(props.time);
        if (!viewer) {
            return;
        }
        const handler = new ScreenSpaceEventHandler(viewer.canvas);
        handler.setInputAction((event: any) => {
            const cartesian3 = viewer.camera.pickEllipsoid(event.endPosition, viewer.scene.globe.ellipsoid);
            if (!cartesian3) {
                setCoordinate({
                    lon: '---',
                    lat: '---'
                })
                return;
            }
            const wgs84Radii = Cartographic.fromCartesian(cartesian3);
            setCoordinate({
                lon: padCoordinate(wgs84Radii.longitude * 180 / Math.PI),
                lat: padCoordinate(wgs84Radii.latitude * 180 / Math.PI),
            })
        }, ScreenSpaceEventType.MOUSE_MOVE)
        return () => {
            handler.destroy();
        }
    }, [props.time])

    return (
        <Paper className="MapInfo">
            <span className="mapinfo-text">
                User: {layerConfig.UserInfo.Email}
            </span>
            <span className="mapinfo-text">
                {time}
            </span>
            <br />
            <span className="mapinfo-text">
                Lon : {coordinate.lon} deg
            </span>
            <span className="mapinfo-text">
                Lat : {coordinate.lat} deg
            </span>
        </Paper>
    )
}
